import ShowTenForecast from "./show-ten-forecast/ShowTenForecast";
import WeatherInfoTable from "./weather-info-table/WeatherInfoTable";
import CityLocation from "@/components/city-location/CityLocation";

import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { useTranslation } from "react-i18next";

import "./style.scss";

export const App = () => {
	const { t } = useTranslation();
	const { forecastData, isLoading, error } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) =>
			select(WEATHER_STORE).getForecastKuwaitState(),
	);

	return (
		<div className="weather-forecast-city">
			<CityLocation locationName={t("kuwait")} showCity={false} />
			<div className="center-content">
				{isLoading ? (
					<div className="weather-info-table">
						<div className="weather-table-header skeleton"></div>
						<div
							className="weather-state skeleton"
							style={{ height: 350 }}
						></div>
					</div>
				) : error ? (
					<div className="error">{t("fetchError")}</div>
				) : (
					<WeatherInfoTable forecastData={forecastData} />
				)}

				<ShowTenForecast />
			</div>
		</div>
	);
};

export default App;
